export enum PromocodeErrors {
  NOT_FOUND = "not-found",
  EXPIRED = "expired",
  NOT_AVAILABLE = "not-available",
  NOT_VALID = "not-valid",
  INVALID_DAYS = "invalid-days",
}
